import { useState } from "react";
import RequestResetPwdForm from "./requestResetPwd";
import SetCodeForm from "./setCode";
import SetNewPasswordForm from "./setNewPwd";
import SuccessMessage from "./successMessage";
import Stepper from "../stepper";

function ResetPasswordForm() {
  const [currentStep, setCurrentStep] = useState(1);
  const stepsTitles = {
    1: "Entrez votre email",
    2: "Entrez le code reçu par email",
    3: "Entrez le nouveau mot de passe",
  };

  const title = stepsTitles[currentStep] || "Réinitialisation de mot de passe";
  return (
    <section id="content-section" className="content-section">
      {currentStep !== 4 ? (
        <>
          <Stepper currentStep={currentStep} />
          <div className="form-content p-5">
            <div className="title-container">
              <h3 className="title">{title}</h3>
            </div>
            <div id="ResetPasswordForm" className="ResetPasswordForm">
              {currentStep === 1 && (
                <RequestResetPwdForm setCurrentStep={setCurrentStep} />
              )}
              {currentStep === 2 && (
                <SetCodeForm setCurrentStep={setCurrentStep} />
              )}
              {currentStep === 3 && (
                <SetNewPasswordForm setCurrentStep={setCurrentStep} />
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <SuccessMessage />
        </>
      )}
    </section>
  );
}

export default ResetPasswordForm;
